import {getGeoType} from "../utils/getGeoType";
import {createEntity} from "./createEntity";
import {getGeomStringForFeature} from "../utils/getGeomStringForFeature";
import {createGeometry} from "./createGeometry";
import {IFeature_CONO} from "../types";

export async function createEntityAndGeometry (feature: IFeature_CONO, type: string, layerid: string) {
    const geoType = getGeoType(feature);
    const entity = await createEntity({
        geoType,
        layerid
    });
    const theGeom = getGeomStringForFeature(feature);
    const entityGeometry = await createGeometry({
        fullUid: entity.fullUid,
        geoType,
        type,
        theGeom
    })
    return {
        entity,
        entityGeometry
    };
}